export const AI_PROMPT_SUGGESTIONS_PREFIX = 'STATIC.PAGES.ANALYSIS_CHAT.EMPTY_STATE.SUGGESTIONS';

export const AI_PROMPT_SUGGESTION_IDS = [
    'COMPARE_PERFORMANCE',
    'SUMMARIZE_ACTIVITY',
    'EXPLAIN_DECREASE',
    'BUILD_DASHBOARD',
];
